import { Button } from "@/components/ui/button"

/**
 * The console's front door.
 *
 * Before this, an unauthenticated visitor got a loading skeleton and a silent
 * `loginRedirect` fired from an effect -- which is how the sign-in loop in
 * `auth.ts` happened: with an active Microsoft SSO session the redirect returned
 * near-instantly, the effect saw no account yet and fired again, and Microsoft
 * eventually broke the cycle with "we couldn't sign you in". Nothing interactive
 * starts here until a human clicks, so that loop cannot form.
 */
export function SignIn({ onSignIn }: { onSignIn: () => void }) {
  return (
    <main className="flex h-svh items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm border border-border bg-card p-6">
        <div className="flex items-center gap-2">
          <img aria-hidden alt="" src="/icon.png" className="size-5 shrink-0" />
          <h1 className="font-mono text-xs font-medium tracking-tight">brain console</h1>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          The steward console for Monterro's company knowledge. Sign in with your Monterro
          account to continue.
        </p>
        <Button className="mt-6 w-full font-mono text-xs" onClick={onSignIn}>
          Sign in with Microsoft
        </Button>
      </div>
    </main>
  )
}
